import React from 'react';
import ReactDOM from 'react-dom/client';
import { ErrorBoundary } from './components/ErrorBoundary';
import { SVVSpinner } from '@komponentkassen/svv-spinner';

import App from './App';

const root = ReactDOM.createRoot(document.getElementById('app') as HTMLElement);
root.render(
    <React.Suspense fallback={<SVVSpinner size="large" />}>
        <ErrorBoundary>
            <App />
        </ErrorBoundary>
    </React.Suspense>,
);
